module.exports = __webpack_public_path__ + "static/media/white-arrow.48a992e4.svg";